import React, { Component } from 'react';
import ARB_NavBar from './components/ARB_NavBar';
import { ArrowRight, RefreshCcw, ChevronDown, Delete, AlertCircle, X } from 'react-feather';
import Autosuggest from 'react-autosuggest';
import { DataARB } from './data/DataARB';
import { CountryNamesARB } from './data/CountryNames';
import { PromptsARB } from './data/Prompts';
import { CaptionARB } from './data/MapCaptions';
import { WorldLow } from './data/WorldLow';
import { DashedLines, DottedLines, SolidLines } from './data/ExtraLines';
// import {DisputedLines} from './data/DisputedLines';

import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4maps from '@amcharts/amcharts4/maps';
import $ from 'jquery';

const sortSpecificResults = (results, records) => {
  return results.sort((a, b) => {
    const aOrder = Number(
      records.find(x => x.SpecificResult === a)?.SpecificResultOrder || 0
    );

    const bOrder = Number(
      records.find(x => x.SpecificResult === b)?.SpecificResultOrder || 0
    );

    return aOrder - bOrder;
  });
};





am4core.useTheme(am4themes_animated);

let clicks = 0;
let selectedCountries = [];
let selectedRecords = [];
let tempBudgetSection = [];
let tempSubprogramme = [];
let tempBeneficiary = [];
let tempPriority = [];
let tempEntity = [];
let selectedSpecifResult = [];
let tempSpecificResults = [];
let polygonSeries;
let dashedLineSeries;
let dottedLineSeries;
let solidLineSeries;
let map;





class ARB extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      activeRecords: [],
      backupActiveRecords: [],
      buffingRecords: [],
      activeISOs: [],
      backupISOs: [],
      checked2025: true,
      checked2027: true,
      activeBudgetSection: '',
      activeSubprogramme: '',
      activeBeneficiary: '',
      activePriority: '',
      activeEntity: '',
      activeSpecificResults: [],
      backupSpecificResults: [],
      specificResultSelected: '',
      budgetSectionSelected: '',
      subprogrammeSelected: '',
      memberStateSelected: '',
      typedResultsCategory: '',
      resultsCategorySuggestions: [],
      beneficiarySelected: '',
      prioritySelected: '',
      entitySelected: '',
    };

    this.handleClick2025 = this.handleClick2025.bind(this);
    this.handleClick2027 = this.handleClick2027.bind(this);
    this.handleSelectBudgetSection = this.handleSelectBudgetSection.bind(this);
    this.handleSelectSubprogramme = this.handleSelectSubprogramme.bind(this);
    this.handleClickRefresh = this.handleClickRefresh.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    // this.handleSelectSpecificResult = this.handleSelectSpecificResult.bind(this);
    this.handleSelectResultsCategory = this.handleSelectResultsCategory.bind(this);
    //this.handleClearTyped = this.handleClearTyped.bind(this);
    this.handleSelectBeneficiary = this.handleSelectBeneficiary.bind(this);
    this.handleSelectPriority = this.handleSelectPriority.bind(this);
    this.handleSelectEntity = this.handleSelectEntity.bind(this);
  }

  // 2025NEW_START
  handleClick2025 = () => {
    tempBudgetSection = [];
    tempSubprogramme = [];
    tempSpecificResults = [];
    tempBeneficiary = [];
    tempPriority = [];
    tempEntity = [];

    let backup = this.state.buffingRecords;

    let story2025 = backup.filter(
      el => el.Type === 2025 || el.TypeTwo === 2025
    );

    let story2027 = backup.filter(
      el => el.Type === 2027
    );

    const nextChecked2025 = !this.state.checked2025;

    let records = [];

    if (nextChecked2025 && !this.state.checked2027) {
      records = story2025;
    } else if (!nextChecked2025 && this.state.checked2027) {
      records = story2027;
    } else if (nextChecked2025 && this.state.checked2027) {
      records = backup;
    } else {
      records = [];
    }

    // Preserve map filter
    if (
      this.state.activeISOs.length === 1 &&
      this.state.memberStateSelected !== ""
    ) {
      const iso = this.state.activeISOs[0];

      records = records.filter(el =>
        el.ISO2.split(",").includes(iso)
      );
    }

    let newSpecificResults = [];

    records.forEach(el => {
      if (!newSpecificResults.includes(el.SpecificResult)) {
        newSpecificResults.push(el.SpecificResult);
      }
    });

    sortSpecificResults(newSpecificResults, records);

    this.setState({
      checked2025: nextChecked2025,
      activeRecords: records,
      activeSpecificResults: newSpecificResults
    });
  };
  // 2025NEW_END

  // 2027NEW_START
  handleClick2027 = () => {

    tempBudgetSection = [];
    tempSubprogramme = [];
    tempSpecificResults = [];
    tempBeneficiary = [];
    tempPriority = [];
    tempEntity = [];

    let backup = this.state.buffingRecords;

    let story2025 = backup.filter(
      el => el.Type === 2025 || el.TypeTwo === 2025
    );

    let story2027 = backup.filter(
      el => el.Type === 2027
    );

    const nextChecked2027 = !this.state.checked2027;

    let records = [];

    if (this.state.checked2025 && !nextChecked2027) {
      records = story2025;
    } else if (!this.state.checked2025 && nextChecked2027) {
      records = story2027;
    } else if (this.state.checked2025 && nextChecked2027) {
      records = backup;
    } else {
      records = [];
    }

    // Preserve map filter
    if (
      this.state.activeISOs.length === 1 &&
      this.state.memberStateSelected !== ""
    ) {
      const iso = this.state.activeISOs[0];

      records = records.filter(el =>
        el.ISO2.split(",").includes(iso)
      );
    }

    let newSpecificResults = [];

    records.forEach(el => {
      if (!newSpecificResults.includes(el.SpecificResult)) {
        newSpecificResults.push(el.SpecificResult);
      }
    });

    sortSpecificResults(newSpecificResults, records);

    this.setState({
      checked2027: nextChecked2027,
      activeRecords: records,
      activeSpecificResults: newSpecificResults
    });
  };
  // 2027NEW_END

  handleSelectBudgetSection = (ev) => {
    //console.log("handleSelectBudgetSection");
    tempBudgetSection = [];
    tempSubprogramme = [];
    tempSpecificResults = [];
    tempBeneficiary = [];
    tempPriority = [];
    tempEntity = [];
    map.goHome();

    let targetSection = ev.target.textContent.split(': ')[1];
    let tempSelectedRecords = this.state.activeRecords.filter((el) => el.Programme === targetSection);
    let tempISOs = [];
    if (this.state.activeISOs.length === 1) {
      tempISOs.push(this.state.activeISOs[0]);


      tempSelectedRecords.map((el) => {
        if (!tempSpecificResults.includes(el.SpecificResult)) {
          tempSpecificResults.push(el.SpecificResult);
        }
      });



      sortSpecificResults(tempSpecificResults, tempSelectedRecords);

      this.setState(
        {
          activeBudgetSection: ev.target.textContent.split(': ')[1],
          activeRecords: tempSelectedRecords,
          buffingRecords: tempSelectedRecords,
          checked2025: true,
          checked2027: true,
          activeSpecificResults: tempSpecificResults,
          budgetSectionSelected: ev.target.textContent,
          activeISOs: tempISOs,
        },
        () => {
          this.state.backupISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = false;
          });
          tempISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = true;
          });
        }
      );
    } else {
      tempSelectedRecords.map((el) => {
        if (!tempSpecificResults.includes(el.SpecificResult)) {
          tempSpecificResults.push(el.SpecificResult);
        }
        el.ISO2.split(',').map((item) => {
          if (!tempISOs.includes(item) && item.length === 2) {
            tempISOs.push(item);
          }
        });
      });

      sortSpecificResults(tempSpecificResults, tempSelectedRecords);

      this.setState(
        {
          activeBudgetSection: ev.target.textContent.split(': ')[1],
          activeRecords: tempSelectedRecords,
          buffingRecords: tempSelectedRecords,
          checked2025: true,
          checked2027: true,
          activeSpecificResults: tempSpecificResults,
          budgetSectionSelected: ev.target.textContent,
          activeISOs: tempISOs,
        },
        () => {
          this.state.backupISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = false;
          });
          tempISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = true;
          });
        }
      );
    }
  };

  handleSelectSubprogramme = (ev) => {

    tempBudgetSection = [];
    tempSubprogramme = [];
    tempSpecificResults = [];
    tempBeneficiary = [];
    tempPriority = [];
    tempEntity = [];
    map.goHome();
    let targetSubprogramme = ev.target.textContent;
    let tempSelectedRecords = this.state.activeRecords.filter((el) => el.Subprogramme === targetSubprogramme);
    let tempISOs = [];
    if (this.state.activeISOs.length === 1) {
      //console.log('aaa');
      tempISOs.push(this.state.activeISOs[0]);
      tempSelectedRecords.map((el) => {
        if (!tempSpecificResults.includes(el.SpecificResult)) {
          tempSpecificResults.push(el.SpecificResult);
        }
      });

      sortSpecificResults(tempSpecificResults, tempSelectedRecords);

      this.setState(
        {
          activeSubprogramme: ev.target.textContent,
          activeRecords: tempSelectedRecords,
          buffingRecords: tempSelectedRecords,
          checked2025: true,
          checked2027: true,
          activeSpecificResults: tempSpecificResults,
          subprogrammeSelected: ev.target.textContent,
          activeISOs: tempISOs,
        },
        () => {
          this.state.backupISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = false;
          });
          tempISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = true;
          });
        }
      );
    } else {
      //console.log('bbb');
      tempSelectedRecords.map((el) => {
        if (!tempSpecificResults.includes(el.SpecificResult)) {
          tempSpecificResults.push(el.SpecificResult);
        }
        el.ISO2.split(',').map((item) => {
          if (!tempISOs.includes(item) && item.length === 2) {
            tempISOs.push(item);
          }
        });
      });

      sortSpecificResults(tempSpecificResults, tempSelectedRecords);

      this.setState(
        {
          activeSubprogramme: ev.target.textContent,
          activeRecords: tempSelectedRecords,
          buffingRecords: tempSelectedRecords,
          checked2025: true,
          checked2027: true,
          activeSpecificResults: tempSpecificResults,
          subprogrammeSelected: ev.target.textContent,
          activeISOs: tempISOs,
        },
        () => {
          this.state.backupISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = false;
          });
          tempISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = true;
          });
        }
      );
    }
  };

  // handleSelectSpecificResult = ()=>{
  //     selectedSpecifResult = $("#dropdownMenuLink").val()
  //     let tempSelectedRecords = this.state.activeRecords.filter(el => el.SpecificResult===selectedSpecifResult);
  //     let tempISOs = [];
  //     tempSelectedRecords.map((el)=>{
  //         el.ISO2.split(",").map((item)=>{
  //             if (!tempISOs.includes(item) && item.length===2){
  //                 tempISOs.push(item)
  //             }
  //         })
  //     })
  //     tempBudgetSection = [];
  //     tempSubprogramme = [];
  //     this.setState({
  //         activeRecords:tempSelectedRecords,
  //         buffingRecords:tempSelectedRecords,
  //         specificResultSelected:selectedSpecifResult,
  //         memberStateSelected:""
  //     },()=>{
  //         this.state.backupISOs.map(el => {
  //             polygonSeries.getPolygonById(el).isActive = false;
  //           });
  //         tempISOs.map(el => {
  //             polygonSeries.getPolygonById(el).isActive = true;
  //           });
  //     })
  // }

  handleClickRefresh = () => {

    tempBudgetSection = [];
    tempSubprogramme = [];
    tempSpecificResults = [];
    tempBeneficiary = [];
    tempPriority = [];
    tempEntity = [];
    map.goHome();
    this.state.activeISOs.map((el) => {
      polygonSeries.getPolygonById(el).isActive = false;
    });
    this.state.backupISOs.map((el) => {
      polygonSeries.getPolygonById(el).isActive = true;
    });
    // document.getElementById("dropdownMenuLink").value=""

    this.setState({
      activeSubprogramme: '',
      activeBudgetSection: '',
      activePriority: '',
      activeEntity: '',
      activeBeneficiary: '',
      activeISOs: this.state.backupISOs,
      activeRecords: this.state.backupActiveRecords,
      buffingRecords: this.state.backupActiveRecords,
      checked2025: true,
      checked2027: true,
      activeSpecificResults: this.state.backupSpecificResults,
      budgetSectionSelected: '',
      subprogrammeSelected: '',
      specificResultSelected: '',
      memberStateSelected: '',
      typedResultsCategory: '',
      beneficiarySelected: '',
      prioritySelected: '',
      entitySelected: '',
    });

    clicks = 0;
  };

  handleSelectBeneficiary = (ev) => {
    tempBudgetSection = [];
    tempSubprogramme = [];
    tempSpecificResults = [];
    tempBeneficiary = [];
    tempPriority = [];
    tempEntity = [];
    map.goHome();
    let targetSection = ev.target.textContent;
    //let tempSelectedRecords = this.state.activeRecords.filter((el) => el.Beneficiary === targetSection);
    let tempSelectedRecords = this.state.activeRecords.filter((el) => el.Beneficiary === targetSection || el.BeneficiaryTwo === targetSection);
    let tempISOs = [];
    if (this.state.activeISOs.length === 1) {
      tempISOs.push(this.state.activeISOs[0]);
      tempSelectedRecords.map((el) => {
        if (!tempSpecificResults.includes(el.SpecificResult)) {
          tempSpecificResults.push(el.SpecificResult);
        }
      });

      sortSpecificResults(tempSpecificResults, tempSelectedRecords);

      this.setState(
        {
          activeBeneficiary: ev.target.textContent,
          activeRecords: tempSelectedRecords,
          buffingRecords: tempSelectedRecords,
          checked2025: true,
          checked2027: true,
          activeSpecificResults: tempSpecificResults,
          beneficiarySelected: ev.target.textContent,
          activeISOs: tempISOs,
        },
        () => {
          this.state.backupISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = false;
          });
          tempISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = true;
          });
        }
      );
    } else {
      tempSelectedRecords.map((el) => {
        if (!tempSpecificResults.includes(el.SpecificResult)) {
          tempSpecificResults.push(el.SpecificResult);
        }
        el.ISO2.split(',').map((item) => {
          if (!tempISOs.includes(item) && item.length === 2) {
            tempISOs.push(item);
          }
        });
      });

      sortSpecificResults(tempSpecificResults, tempSelectedRecords);

      this.setState(
        {
          activeBeneficiary: ev.target.textContent,
          activeRecords: tempSelectedRecords,
          buffingRecords: tempSelectedRecords,
          checked2025: true,
          checked2027: true,
          activeSpecificResults: tempSpecificResults,
          beneficiarySelected: ev.target.textContent,
          activeISOs: tempISOs,
        },
        () => {
          this.state.backupISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = false;
          });
          tempISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = true;
          });
        }
      );
    }
  };

  handleSelectPriority = (ev) => {
    
    tempBudgetSection = [];
    tempSubprogramme = [];
    tempSpecificResults = [];
    tempBeneficiary = [];
    tempPriority = [];
    tempEntity = [];
    map.goHome();
    let targetSection = ev.target.textContent;
    let tempSelectedRecords = this.state.activeRecords.filter((el) => el.Priority === targetSection);
    let tempISOs = [];
    if (this.state.activeISOs.length === 1) {
      tempISOs.push(this.state.activeISOs[0]);
      tempSelectedRecords.map((el) => {
        if (!tempSpecificResults.includes(el.SpecificResult)) {
          tempSpecificResults.push(el.SpecificResult);
        }
      });

      sortSpecificResults(tempSpecificResults, tempSelectedRecords);

      this.setState(
        {
          activePriority: ev.target.textContent,
          activeRecords: tempSelectedRecords,
          buffingRecords: tempSelectedRecords,
          checked2025: true,
          checked2027: true,
          activeSpecificResults: tempSpecificResults,
          prioritySelected: ev.target.textContent,
          activeISOs: tempISOs,
        },
        () => {
          this.state.backupISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = false;
          });
          tempISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = true;
          });
        }
      );
    } else {
      tempSelectedRecords.map((el) => {
        if (!tempSpecificResults.includes(el.SpecificResult)) {
          tempSpecificResults.push(el.SpecificResult);
        }
        el.ISO2.split(',').map((item) => {
          if (!tempISOs.includes(item) && item.length === 2) {
            tempISOs.push(item);
          }
        });
      });

      sortSpecificResults(tempSpecificResults, tempSelectedRecords);

      this.setState(
        {
          activePriority: ev.target.textContent,
          activeRecords: tempSelectedRecords,
          buffingRecords: tempSelectedRecords,
          checked2025: true,
          checked2027: true,
          activeSpecificResults: tempSpecificResults,
          prioritySelected: ev.target.textContent,
          activeISOs: tempISOs,
        },
        () => {
          this.state.backupISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = false;
          });
          tempISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = true;
          });
        }
      );
    }
  };

//ENTITY HANDLER START
  handleSelectEntity = (ev) => {
	//console.log("handleSelectPriority");
    tempBudgetSection = [];
    tempSubprogramme = [];
    tempSpecificResults = [];
    tempBeneficiary = [];
    tempPriority = [];
    tempEntity = [];
    map.goHome();
    let targetSection = ev.target.textContent;
    let tempSelectedRecords = this.state.activeRecords.filter((el) => el.EntityFullName === targetSection);
    let tempISOs = [];
    if (this.state.activeISOs.length === 1) {
      tempISOs.push(this.state.activeISOs[0]);
      tempSelectedRecords.map((el) => {
        if (!tempSpecificResults.includes(el.SpecificResult)) {
          tempSpecificResults.push(el.SpecificResult);
        }
      });

      sortSpecificResults(tempSpecificResults, tempSelectedRecords);

      this.setState(
        {
          activeEntity: ev.target.textContent,
          activeRecords: tempSelectedRecords,
          buffingRecords: tempSelectedRecords,
          checked2025: true,
          checked2027: true,
          activeSpecificResults: tempSpecificResults,
          entitySelected: ev.target.textContent,
          activeISOs: tempISOs,
        },
        () => {
          this.state.backupISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = false;
          });
          tempISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = true;
          });
        }
      );
    } else {
      tempSelectedRecords.map((el) => {
        if (!tempSpecificResults.includes(el.SpecificResult)) {
          tempSpecificResults.push(el.SpecificResult);
        }
        el.ISO2.split(',').map((item) => {
          if (!tempISOs.includes(item) && item.length === 2) {
            tempISOs.push(item);
          }
        });
      });

      sortSpecificResults(tempSpecificResults, tempSelectedRecords);

      this.setState(
        {
          activeEntity: ev.target.textContent,
          activeRecords: tempSelectedRecords,
          buffingRecords: tempSelectedRecords,
          checked2025: true,
          checked2027: true,
          activeSpecificResults: tempSpecificResults,
          entitySelected: ev.target.textContent,
          activeISOs: tempISOs,
        },
        () => {
          this.state.backupISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = false;
          });
          tempISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = true;
          });
        }
      );
    }
  };
//ENTITY HANDLER END  

  handleMouseEnter = (event) => {
    try {
      if (event.target.className === 'card-body') {
        let targetID = event.target.querySelector('img').id;
        document.getElementById(targetID).style.display = 'flex';
      }
    } catch (error) {
      //console.log('no image');
    }
  };




  handleMouseLeave = (event) => {
    try {
      if (event.target.className === 'card-body') {
        let targetID = event.target.querySelector('img').id;
        document.getElementById(targetID).style.display = 'none';
      }
    } catch (error) {
      //console.log('no image');
    }
  };

  handleSelectResultsCategory = (ev) => {
    if (this.state.activeSpecificResults.includes($('#dropdownMenuLink').val()) === true) {
      selectedSpecifResult = $('#dropdownMenuLink').val();
      let tempSelectedRecords = this.state.activeRecords.filter((el) => el.SpecificResult === selectedSpecifResult);
      let tempISOs = [];
      tempBudgetSection = [];
      tempSubprogramme = [];

      tempBeneficiary = [];
      tempPriority = [];
      tempEntity = [];
      if (this.state.activeISOs.length === 1) {
        tempISOs.push(this.state.activeISOs[0]);
        this.setState(
          {
            activeRecords: tempSelectedRecords,
            buffingRecords: tempSelectedRecords,
            specificResultSelected: selectedSpecifResult,
            // activeSpecificResults:[selectedSpecifResult],
            activeISOs: tempISOs,
          },
          () => {
            this.setState({
              activeISOs: tempISOs,
            });
            this.state.backupISOs.map((el) => {
              polygonSeries.getPolygonById(el).isActive = false;
            });
            tempISOs.map((el) => {
              polygonSeries.getPolygonById(el).isActive = true;
            });
            tempBudgetSection = [];
            tempSubprogramme = [];
		    tempBeneficiary = [];
		    tempPriority = [];
        tempEntity = [];
          }
        );
      } else {
        tempSelectedRecords.map((el) => {
          el.ISO2.split(',').map((item) => {
            if (!tempISOs.includes(item) && item.length === 2) {
              tempISOs.push(item);
            }
          });
        });
        this.setState(
          {
            // activeSpecificResults:[selectedSpecifResult],
            activeRecords: tempSelectedRecords,
            buffingRecords: tempSelectedRecords,
            specificResultSelected: selectedSpecifResult,
            memberStateSelected: '',
          },
          () => {
            this.setState({
              activeISOs: tempISOs,
            });
            this.state.backupISOs.map((el) => {
              polygonSeries.getPolygonById(el).isActive = false;
            });
            tempISOs.map((el) => {
              polygonSeries.getPolygonById(el).isActive = true;
            });
            tempBudgetSection = [];
            tempSubprogramme = [];
		    tempBeneficiary = [];
		    tempPriority = [];
        tempEntity = [];
          }
        );
      }
    }
  };





  handleClearTyped = () => {
    if (this.state.activeISOs.length > 1) {
      tempBudgetSection = [];
      tempSubprogramme = [];
      tempSpecificResults = [];
      tempBeneficiary = [];
      tempPriority = [];
      tempEntity = [];
      let tempISOs = [];
      let tempSelectedRecords = this.state.backupActiveRecords
        .filter((el) =>
          this.state.activeBudgetSection !== '' ? el.Programme === this.state.activeBudgetSection : el.Programme !== 'ChuanzeCai'
        )
        .filter((el) =>
          this.state.activeSubprogramme !== '' ? el.Subprogramme === this.state.activeSubprogramme : el.Subprogramme !== 'ChuanzeCai'
        )
        .filter((el) =>
          this.state.memberStateSelected !== '' ? el.ISO2.split(',').includes(this.state.activeISOs[0]) : el.ISO2.length >= 0
        );

      tempSelectedRecords.map((el) => {
        el.ISO2.split(',').map((item) => {
          if (!tempISOs.includes(item) && item.length === 2) {
            tempISOs.push(item);
          }
        });
      });
      this.setState(
        {
          resultsCategorySuggestions: [],
          typedResultsCategory: '',
          activeRecords: tempSelectedRecords,
          specificResultSelected: '',
          activeISOs: tempISOs,
        },
        () => {
          this.state.backupISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = false;
          });
          tempISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = true;
          });
        }
      );
    } else {
      tempBudgetSection = [];
      tempSubprogramme = [];
      tempBeneficiary = [];
      tempPriority = [];
      tempEntity = [];
      let tempISOs = [this.state.activeISOs[0]];
      let tempSelectedRecords = this.state.backupActiveRecords
        .filter((el) =>
          this.state.activeBudgetSection !== '' ? el.Programme === this.state.activeBudgetSection : el.Programme !== 'ChuanzeCai'
        )
        .filter((el) =>
          this.state.activeSubprogramme !== '' ? el.Subprogramme === this.state.activeSubprogramme : el.Subprogramme !== 'ChuanzeCai'
        )
        .filter((el) =>
          this.state.memberStateSelected !== '' ? el.ISO2.split(',').includes(this.state.activeISOs[0]) : el.ISO2.length >= 0
        );

      this.setState(
        {
          resultsCategorySuggestions: [],
          typedResultsCategory: '',
          activeRecords: tempSelectedRecords,
          specificResultSelected: '',
          activeISOs: tempISOs,
        },
        () => {
          this.state.backupISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = false;
          });
          tempISOs.map((el) => {
            polygonSeries.getPolygonById(el).isActive = true;
          });
        }
      );
    }
  };


  // componentWillMount() {
  // React is changing componentWillMount name to UNSAFE_componentWillMount in 17.0
  UNSAFE_componentWillMount() {
    let activeISOList = [];
    let activeIDList = [];
    let activeRecordList = [];
    let activeSpecificResults = [];
    DataARB.map((el) => {
      activeIDList.push(el.ID);

      el.ISO2.split(',').map((item) => {
        if (!activeISOList.includes(item) && item.length === 2) {
          activeISOList.push(item);
        }
      });

      if (!activeSpecificResults.includes(el.SpecificResult)) {
        activeSpecificResults.push(el.SpecificResult);
      }
    });

    sortSpecificResults(activeSpecificResults, DataARB);

    DataARB.map((el) => {
      if (activeIDList.includes(el.ID)) {
        activeRecordList.push(el);
      }
    });

    this.setState({
      activeRecords: activeRecordList,
      activeISOs: activeISOList,
      backupActiveRecords: activeRecordList,
      backupISOs: activeISOList,
      buffingRecords: activeRecordList,
      activeSpecificResults: activeSpecificResults,
      backupSpecificResults: activeSpecificResults,
    });
  }

  componentDidMount() {
    let currentInstance = this;

    map = am4core.create('chartdiv', am4maps.MapChart);
    map.geodata = WorldLow[0];
    let dataDeepCopy = JSON.parse(JSON.stringify(map.geodata));
    dataDeepCopy.features.forEach((feature) => {
      var englishMapping = CountryNamesARB[feature.properties.id];
      feature.properties.nameARB = englishMapping;
    });
    map.geodata = dataDeepCopy;

    map.projection = new am4maps.projections.Miller();
    polygonSeries = new am4maps.MapPolygonSeries();
    dashedLineSeries = new am4maps.MapLineSeries();
    dottedLineSeries = new am4maps.MapLineSeries();
    solidLineSeries = new am4maps.MapLineSeries();
    map.series.push(polygonSeries);
    map.series.push(dashedLineSeries);
    map.series.push(dottedLineSeries);
    map.series.push(solidLineSeries);
    polygonSeries.useGeodata = true;
    dashedLineSeries.data = DashedLines;
    dottedLineSeries.data = DottedLines;
    solidLineSeries.data = SolidLines;

    let polygonTemplate = polygonSeries.mapPolygons.template;
    let dashedLineTemplate = dashedLineSeries.mapLines.template;
    let dottedLineTemplate = dottedLineSeries.mapLines.template;
    let solidLineTemplate = solidLineSeries.mapLines.template;

    // Disable the caret pointer on the tooltip
    if (!polygonTemplate.tooltip) {
      polygonTemplate.tooltip = new am4core.Tooltip();
    }
    polygonTemplate.tooltip.background.pointerLength = 0;
    polygonTemplate.tooltip.dy = -10;


    dashedLineTemplate.stroke = am4core.color('#ffffff');
    dashedLineTemplate.opacity = 0.7//0.2;
    dottedLineTemplate.stroke = am4core.color('#ffffff');
    solidLineTemplate.stroke = am4core.color('#ffffff'); // <<<

    dottedLineTemplate.opacity = 0.2;
    solidLineTemplate.opacity = 0.2;
    dottedLineTemplate.opacity = 0.9;
    solidLineTemplate.opacity = 0.9;

    dashedLineSeries.strokeDasharray = 0.7; // <<<
    dottedLineSeries.strokeDasharray = 0.15; // <<<

    dashedLineSeries.dispatchImmediately(); // <<<
    solidLineTemplate.stroke = am4core.color('#ffffff');
    solidLineTemplate.strokeWidth = 0.2;
    dashedLineSeries.opacity = 0.2;
    dashedLineSeries.strokeDasharray = 0.7;
    dashedLineSeries.dispatchImmediately();
    dottedLineSeries.opacity = 0.5;
    
    dottedLineSeries.strokeDasharray = '0.1,0.5';
    dottedLineSeries.dispatchImmediately();
    dottedLineSeries.opacity = 0.2;
    // dottedLineSeries.strokeDasharray = 0.1;
    dottedLineSeries.dispatchImmediately();

    polygonTemplate.adapter.add('tooltipHTML', (text, target) => {
      let data = target.tooltipDataItem.dataContext;
      if (data.id === 'PS') {
        return '<i>' + data.nameARB + '</i>';
      } else {
        return data.nameARB;
      }
    });

    polygonTemplate.applyOnClones = true;
    polygonTemplate.togglable = true;
    polygonTemplate.nonScalingStroke = true;
    polygonTemplate.strokeOpacity = 0;

    // Create hover state and set alternative fill color
    map.colors.list = [am4core.color('#cbcbcb'), am4core.color('#00b0f1'), am4core.color('#cbcbcb')];
    polygonTemplate.fill = map.colors.getIndex(0);
    let activeState = polygonTemplate.states.create('active');
    activeState.properties.fill = map.colors.getIndex(1);
    let hs = polygonTemplate.states.create('hover');
    hs.properties.fill = map.colors.getIndex(2);

    polygonSeries.exclude = ['AQ'];

    map.zoomControl = new am4maps.ZoomControl();
    map.zoomControl.slider.height = 50;
    map.maxZoomLevel = 3;

    let homeButton = new am4core.Button();
    homeButton.icon = new am4core.Sprite();
    homeButton.padding(7, 5, 7, 5);
    homeButton.width = 30;
    homeButton.icon.path = 'M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8';
    homeButton.marginBottom = 10;
    homeButton.parent = map.zoomControl;
    homeButton.insertBefore(map.zoomControl.plusButton);
    homeButton.events.on('hit', function () {
	    tempBudgetSection = [];
	    tempSubprogramme = [];
	    tempSpecificResults = [];
	    tempBeneficiary = [];
	    tempPriority = [];
      tempEntity = [];
	    map.goHome();
        currentInstance.state.activeISOs.map((el) => {
          polygonSeries.getPolygonById(el).isActive = false;
        });
        currentInstance.state.backupISOs.map((el) => {
          polygonSeries.getPolygonById(el).isActive = true;
        });
	    // document.getElementById("dropdownMenuLink").value=""

	    currentInstance.setState({
	      activeSubprogramme: '',
	      activeBudgetSection: '',
	      activePriority: '',
        activeEntity: '',
	      activeBeneficiary: '',
	      activeISOs: currentInstance.state.backupISOs,
	      activeRecords: currentInstance.state.backupActiveRecords,
	      buffingRecords: currentInstance.state.backupActiveRecords,
	      checked2025: true,
	      checked2027: true,
	      activeSpecificResults: currentInstance.state.backupSpecificResults,
	      budgetSectionSelected: '',
	      subprogrammeSelected: '',
	      specificResultSelected: '',
	      memberStateSelected: '',
	      typedResultsCategory: '',
	      beneficiarySelected: '',
	      prioritySelected: '',
        entitySelected: '',
	    });
	    clicks = 0;
	  });

    polygonSeries.events.on('ready', function () {
      currentInstance.state.activeISOs.map((el) => {
        polygonSeries.getPolygonById(el).isActive = true;
      });
    });

    polygonTemplate.events.on('hit', function (event) {
      if (
        currentInstance.state.activeISOs.includes(event.target.dataItem.dataContext.id) &&
        currentInstance.state.backupISOs.includes(event.target.dataItem.dataContext.id)
      ) {
        //console.log('xxx');
        tempBudgetSection = [];
        tempSubprogramme = [];
        tempSpecificResults = [];
        tempBeneficiary = [];
        tempPriority = [];
        tempEntity = [];
        currentInstance.state.backupISOs.map((el) => {
          polygonSeries.getPolygonById(el).isActive = false;
        });
        polygonSeries.getPolygonById(event.target.dataItem.dataContext.id).isActive = false;
        selectedRecords = [];
        currentInstance.state.activeRecords.map((el) => {
          if (el.ISO2.split(',').includes(event.target.dataItem.dataContext.id)) {
            selectedRecords.push(el);
            if (!tempSpecificResults.includes(el.SpecificResult)) {
              tempSpecificResults.push(el.SpecificResult);
            }
          }
        });

        sortSpecificResults(tempSpecificResults, selectedRecords);


        currentInstance.setState(
          {
            activeRecords: selectedRecords,
            memberStateSelected: event.target.dataItem.dataContext.id,
            activeSpecificResults: tempSpecificResults,
            activeISOs: [],
          },
          () => {
            currentInstance.setState({ activeISOs: [event.target.dataItem.dataContext.id] });
            tempBudgetSection = [];
            tempSubprogramme = [];
            tempSpecificResults = [];
            tempBeneficiary = [];
            tempPriority = [];
            tempEntity = [];
          }
        );
      } else if (
        !currentInstance.state.activeISOs.includes(event.target.dataItem.dataContext.id) &&
        currentInstance.state.backupISOs.includes(event.target.dataItem.dataContext.id)
      ) {
        //console.log('yyy');
        tempBudgetSection = [];
        tempSubprogramme = [];
        tempSpecificResults = [];
        tempBeneficiary = [];
        tempPriority = [];
        tempEntity = [];
        currentInstance.state.backupISOs.map((el) => {
          polygonSeries.getPolygonById(el).isActive = false;
        });
        polygonSeries.getPolygonById(event.target.dataItem.dataContext.id).isActive = false;
        selectedRecords = [];
        currentInstance.state.backupActiveRecords.map((el) => {
          if (el.ISO2.split(',').includes(event.target.dataItem.dataContext.id)) {
            selectedRecords.push(el);
            if (!tempSpecificResults.includes(el.SpecificResult)) {
              tempSpecificResults.push(el.SpecificResult);
            }
          }
        });

        sortSpecificResults(tempSpecificResults, selectedRecords);

        currentInstance.setState(
          {
            activeRecords: selectedRecords,
            buffingRecords: selectedRecords,
            memberStateSelected: event.target.dataItem.dataContext.id,
            checked2025: true,
            checked2027: true,
            //memberStateSelected: event.target.dataItem.dataContext,
            budgetSectionSelected: '',
            subprogrammeSelected: '',
            specificResultSelected: '',
            activeSpecificResults: tempSpecificResults,
            activeBudgetSection: '',
            activeISOs: [],
            typedResultsCategory: '',
          },
          () => {
            currentInstance.setState({ activeISOs: [event.target.dataItem.dataContext.id] });
            tempBudgetSection = [];
            tempSubprogramme = [];
            tempSpecificResults = [];
            tempBeneficiary = [];
            tempPriority = [];
            tempEntity = [];
          }
        );
      } else {
        //console.log('zzz');
        tempBudgetSection = [];
        tempSubprogramme = [];
        tempSpecificResults = [];
        tempBeneficiary = [];
        tempPriority = [];
        tempEntity = [];
        currentInstance.state.backupISOs.map((el) => {
          polygonSeries.getPolygonById(el).isActive = false;
        });
        polygonSeries.getPolygonById(event.target.dataItem.dataContext.id).isActive = true;
        currentInstance.setState(
          {
            activeRecords: [],
            buffingRecords: [],
            memberStateSelected: event.target.dataItem.dataContext.id,
            checked2025: true,
            checked2027: true,
            //memberStateSelected: event.target.dataItem.dataContext,
            budgetSectionSelected: '',
            subprogrammeSelected: '',
            specificResultSelected: '',
            activeSpecificResults: tempSpecificResults,
            activeBudgetSection: '',
            activeISOs: [],
            typedResultsCategory: '',
          },
          () => {
            currentInstance.setState({ activeISOs: [event.target.dataItem.dataContext.id] });
            tempBudgetSection = [];
            tempSubprogramme = [];
            tempSpecificResults = [];
            tempBeneficiary = [];
            tempPriority = [];
            tempEntity = [];
          }
        );
      }
      // else{
      //     console.log('yyy')
      //     document.getElementById("dropdownMenuLink").value=""
      //     tempBudgetSection = [];
      //     tempSubprogramme = [];
      //     tempSpecificResults = [];
      //     currentInstance.state.backupISOs.map(el => {
      //         polygonSeries.getPolygonById(el).isActive = false;
      //       });
      //     // event.target.series.chart.zoomToMapObject(event.target);
      //     let currentCountry = event.target.dataItem.dataContext.id;
      //     if (clicks === 0) {
      //         selectedCountries = [];
      //         currentInstance.state.activeISOs.map(el => {
      //             polygonSeries.getPolygonById(el).isActive = false;
      //           });
      //       }
      //     clicks = 1;
      //     selectedCountries.push(currentCountry);
      //     if (clicks !== 0 && event.target.isActive === true) {
      //         selectedCountries = selectedCountries.filter(el => {
      //           return el !== currentCountry;
      //         });
      //       }

      //     selectedRecords = [];
      //     currentInstance.state.backupActiveRecords.map((el)=>{
      //         selectedCountries.map((item)=>{
      //             if (el.ISO2.includes(item) && !selectedRecords.includes(el)){
      //                 selectedRecords.push(el)
      //             }
      //         })
      //     })

      //     selectedRecords.map(el=>{
      //         if(!tempSpecificResults.includes(el.SpecificResult)){
      //             tempSpecificResults.push(el.SpecificResult)
      //         }
      //     })

      //     currentInstance.setState({
      //         activeRecords:selectedRecords,
      //         buffingRecords:selectedRecords,
      //         checked2024:true,
      //         checked2026:true,
      //         memberStateSelected:event.target.dataItem.dataContext,
      //         budgetSectionSelected:"",
      //         subprogrammeSelected:"",
      //         specificResultSelected:"",
      //         activeSpecificResults:tempSpecificResults,
      //         activeBudgetSection:""
      //         });
      // }
      

      // HIGHLIGHT TERRITORY WITH EGYPT ---- START
      if (event.target.dataItem.dataContext.id === 'QG') {
        polygonSeries.getPolygonById('EG').isActive = true;
        polygonSeries.getPolygonById('EG').fill = event.target.fill;
      } else {
        polygonSeries.getPolygonById('EG').isActive = false;
      }
      
      if (event.target.dataItem.dataContext.id === 'EG') {
        polygonSeries.getPolygonById('QG').isActive = true;
        polygonSeries.getPolygonById('QG').fill = event.target.fill; 
      } else {
        polygonSeries.getPolygonById('QG').isActive = false;
      }
      // HIGHLIGHT TERRITORY WITH EGYPT---- END
      
      // HIGHLIGHT TERRITORY WITH NORTH SUDAN ---- START
      if (event.target.dataItem.dataContext.id === 'QQ') {
        polygonSeries.getPolygonById('SD').isActive = true;
        polygonSeries.getPolygonById('SD').fill = event.target.fill;
      } else {
        polygonSeries.getPolygonById('SD').isActive = false;
      }
      
      if (event.target.dataItem.dataContext.id === 'SD') {
        polygonSeries.getPolygonById('QQ').isActive = true;
        polygonSeries.getPolygonById('QQ').fill = event.target.fill; 
      } else {
        polygonSeries.getPolygonById('QQ').isActive = false;
      }
      // HIGHLIGHT TERRITORY WITH NORTH SUDAN ---- END

      // HIGHLIGHT ESP SOVEREIGNTY ISLANDS WITH SPAIN ---- START
      if (event.target.dataItem.dataContext.id === 'ES') {
        // If the clicked polygon is IN, make AP active and set the same color
        polygonSeries.getPolygonById('EI').isActive = true;
        polygonSeries.getPolygonById('EI').fill = event.target.fill;
      } else {
        polygonSeries.getPolygonById('EI').isActive = false;
      }
      
      if (event.target.dataItem.dataContext.id === 'EI') {
        // If the clicked polygon is IN, make AP active and set the same color
        polygonSeries.getPolygonById('ES').isActive = true;
        polygonSeries.getPolygonById('ES').fill = event.target.fill; 
      } else {
        polygonSeries.getPolygonById('ES').isActive = false;
      }
      // HIGHLIGHT ESP SOVEREIGNTY ISLANDS WITH SPAIN ---- END

      // HIGHLIGHT PRT SOVEREIGNTY ISLANDS WITH PORTUGAL ---- START
      if (event.target.dataItem.dataContext.id === 'PT') {
        // If the clicked polygon is IN, make AP active and set the same color
        polygonSeries.getPolygonById('PI').isActive = true;
        polygonSeries.getPolygonById('PI').fill = event.target.fill;
      } else {
        polygonSeries.getPolygonById('PI').isActive = false;
      }
      
      if (event.target.dataItem.dataContext.id === 'PI') {
        // If the clicked polygon is IN, make AP active and set the same color
        polygonSeries.getPolygonById('PT').isActive = true;
        polygonSeries.getPolygonById('PT').fill = event.target.fill; 
      } else {
        polygonSeries.getPolygonById('PT').isActive = false;
      }
      // HIGHLIGHT PRT SOVEREIGNTY ISLANDS WITH PORTUGAL  ---- END
      
      // HIGHLIGHT ILEMI TRIANGLE WITH SOUTH SUDAN ---- START
      if (event.target.dataItem.dataContext.id === 'II') {
        // If the clicked polygon is IN, make AP active and set the same color
        polygonSeries.getPolygonById('SS').isActive = true;
        polygonSeries.getPolygonById('SS').fill = event.target.fill;
      } else {
        polygonSeries.getPolygonById('SS').isActive = false;
      }
      
      if (event.target.dataItem.dataContext.id === 'SS') {
        // If the clicked polygon is IN, make AP active and set the same color
        polygonSeries.getPolygonById('II').isActive = true;
        polygonSeries.getPolygonById('II').fill = event.target.fill; 
      } else {
        polygonSeries.getPolygonById('II').isActive = false;
      }
      // HIGHLIGHT ILEMI TRIANGLE WITH SOUTH SUDAN ---- END


      // HIGHLIGHT ARUNACHAL PRADESH WITH INDIA ---- START
      if (event.target.dataItem.dataContext.id === 'IN') {
        // If the clicked polygon is IN, make AP active and set the same color
        polygonSeries.getPolygonById('AP').isActive = true;
        polygonSeries.getPolygonById('AP').fill = event.target.fill;
      } else {
        polygonSeries.getPolygonById('AP').isActive = false;
      }
      
      if (event.target.dataItem.dataContext.id === 'AP') {
        // If the clicked polygon is IN, make AP active and set the same color
        polygonSeries.getPolygonById('IN').isActive = true;
        polygonSeries.getPolygonById('IN').fill = event.target.fill; 
      } else {
        polygonSeries.getPolygonById('IN').isActive = false;
      }
      // HIGHLIGHT ARUNACHAL PRADESH WITH INDIA ---- END
      
      // HIGHLIGHT KUNASHIR WITH RUSSIA ---- START
      if (event.target.dataItem.dataContext.id === 'KU') {
        polygonSeries.getPolygonById('RU').isActive = true;
        polygonSeries.getPolygonById('RU').fill = event.target.fill;
      } else {
        polygonSeries.getPolygonById('RU').isActive = false;
      }
      
      if (event.target.dataItem.dataContext.id === 'RU') {
        polygonSeries.getPolygonById('KU').isActive = true;
        polygonSeries.getPolygonById('KU').fill = event.target.fill; 
      } else {
        polygonSeries.getPolygonById('KU').isActive = false;
      }
      // HIGHLIGHT KUNASHIR WITH RUSSIA ---- END

      // HIGHLIGHT TAIWAN/HONGKONG/MACAU/AKSAI SHIN STRIPES WITH CHINA ---- START
      if (event.target.dataItem.dataContext.id === 'CN') {
        // If the clicked polygon is CN, make HK/TW/MO active and set the same color
        polygonSeries.getPolygonById('HK').isActive = true;
        polygonSeries.getPolygonById('HK').fill = event.target.fill; // Set the same color as CN
        polygonSeries.getPolygonById('TW').isActive = true;
        polygonSeries.getPolygonById('TW').fill = event.target.fill; // Set the same color as CN
        polygonSeries.getPolygonById('MO').isActive = true;
        polygonSeries.getPolygonById('MO').fill = event.target.fill; // Set the same color as CN
        polygonSeries.getPolygonById('KX').isActive = true;
        polygonSeries.getPolygonById('KX').fill = event.target.fill; // Set the same color as CN
      } else if (event.target.dataItem.dataContext.id === 'TW') {
        // Or if the clicked polygon is TW, make HK/CN/MO active and set the same color
        polygonSeries.getPolygonById('HK').isActive = true;
        polygonSeries.getPolygonById('HK').fill = event.target.fill; 
        polygonSeries.getPolygonById('CN').isActive = true;
        polygonSeries.getPolygonById('CN').fill = event.target.fill; 
        polygonSeries.getPolygonById('MO').isActive = true;
        polygonSeries.getPolygonById('MO').fill = event.target.fill;
        polygonSeries.getPolygonById('KX').isActive = true;
        polygonSeries.getPolygonById('KX').fill = event.target.fill; // Set the same color as CN 
      } else if (event.target.dataItem.dataContext.id === 'HK') {
        // Or if the clicked polygon is HK, make TW/CN/MO active and set the same color
        polygonSeries.getPolygonById('TW').isActive = true;
        polygonSeries.getPolygonById('TW').fill = event.target.fill; 
        polygonSeries.getPolygonById('CN').isActive = true;
        polygonSeries.getPolygonById('CN').fill = event.target.fill; 
        polygonSeries.getPolygonById('MO').isActive = true;
        polygonSeries.getPolygonById('MO').fill = event.target.fill;
        polygonSeries.getPolygonById('KX').isActive = true;
        polygonSeries.getPolygonById('KX').fill = event.target.fill; // Set the same color as CN
      } else if (event.target.dataItem.dataContext.id === 'MO') {
        // Or if the clicked polygon is MO, make TW/CN/HK active and set the same color
        polygonSeries.getPolygonById('TW').isActive = true;
        polygonSeries.getPolygonById('TW').fill = event.target.fill;
        polygonSeries.getPolygonById('CN').isActive = true;
        polygonSeries.getPolygonById('CN').fill = event.target.fill;
        polygonSeries.getPolygonById('HK').isActive = true;
        polygonSeries.getPolygonById('HK').fill = event.target.fill;
        polygonSeries.getPolygonById('KX').isActive = true;
        polygonSeries.getPolygonById('KX').fill = event.target.fill; // Set the same color as CN
      } else if (event.target.dataItem.dataContext.id === 'KX') {
        // Or if the clicked polygon is MO, make TW/CN/HK active and set the same color
        polygonSeries.getPolygonById('TW').isActive = true;
        polygonSeries.getPolygonById('TW').fill = event.target.fill;
        polygonSeries.getPolygonById('CN').isActive = true;
        polygonSeries.getPolygonById('CN').fill = event.target.fill;
        polygonSeries.getPolygonById('HK').isActive = true;
        polygonSeries.getPolygonById('HK').fill = event.target.fill;
        polygonSeries.getPolygonById('MO').isActive = true;
        polygonSeries.getPolygonById('MO').fill = event.target.fill; // Set the same color as CN
      } else {
        // Otherwise, CN/TW/HK/MO all inactive
        polygonSeries.getPolygonById('CN').isActive = false;
        polygonSeries.getPolygonById('TW').isActive = false;
        polygonSeries.getPolygonById('HK').isActive = false;
        polygonSeries.getPolygonById('MO').isActive = false;
        polygonSeries.getPolygonById('KX').isActive = false;
      }
      // HIGHLIGHT TAIWAN/HONGKONG/MACAU/AKSAI CHIN STRIPES WITH CHINA ---- END
    });
  }

  componentWillUnmount() {
  if (map) {
    map.dispose();
    map = null;
  }
}

  render() {
    return (
      <React.Fragment>
        <ARB_NavBar 
          aboutUsContext1={PromptsARB.aboutUs1}
          aboutUsContext2={PromptsARB.aboutUs2}
          aboutUsContext3={PromptsARB.aboutUs3}
          aboutUsContext4={PromptsARB.aboutUs4}
          aboutUsContext5={PromptsARB.aboutUs5}
          aboutUsContext6={PromptsARB.aboutUs6}
          aboutUsTitle={PromptsARB.aboutUsTitle}
        />


        {/* <div className='row border-bottom text-right'>
          <h2 className='col-lg-12 col-sm-12 col-md-12 display-5 p-2 text-secondary'>{PromptsARB.title}</h2>
          <p className='text-secondary about px-2 mb-2'>{PromptsARB.about}</p>
        </div> */}


        <div class="page-wrapper" dir='rtl'>
          {/* new begin  */}
                    <div className="logo-title-main-arb">
                      <a href="https://www.un.org/ar" target="_blank" rel="noopener noreferrer">
                          <img
                            src="/img/UN-logo-ar.svg"
                            className="un-logo-arb"
                            alt="UN Logo"
                          />
                        </a>

                      <div className="logo-divider"></div>
                      <div className="logo-divider-mobile-arb"></div>

                      <div className="title-about-container-arb">  
                        <h2 className="title-text-arb" dir='rtl'>
                          <a href="/ARB" style={{ textDecoration: 'none', color: 'inherit' }}>{PromptsARB.title}
                          </a>

                        </h2>
                        <p className="about-text-arb">{PromptsARB.about} </p>
          
                      </div>
          
                    </div>
                  {/* new end */}


             {/* <div className='row container-fluid filter-bars text-right' dir='rtl'> */}
            <div className='container-fluid filter-bars pr-0 pr-md-2' dir='rtl'>
              <div className='row pr-2'>

                <div class="accordion px-0" id="filtersAccordion">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="filtersHeading">
                      <button 
                        class="accordion-button collapsed" 
                        type="button" 
                        data-bs-toggle="collapse" 
                        data-bs-target="#filtersCollapse" 
                        aria-expanded="false" 
                        aria-controls="filtersCollapse"
                      >
                      المرشحات
                      &nbsp;
                      </button>
                    </h2>
                    <div 
                      id="filtersCollapse" 
                      class="accordion-collapse collapse" 
                      aria-labelledby="filtersHeading" 
                      data-bs-parent="#filtersAccordion"
                      >

                      <div className='row container-fluid filter-bars'> {/*Makes the filter buttons stack horizontally*/}
                
                      {/* Entity start */}
                      <div className='col-sm-6 col-md-6 col-lg-2 text-secondary px-2 pb-3 margin-10'>
                        
                          {/*<div className='col-sm-6 col-md-6 col-lg-3 text-secondary px-2 padding-top-20'>*/}
                          <div className='filterLabel'>
                          <small>{PromptsARB.entityTitle}</small>
                          </div>
                          <div className='dropdown'>
                            <a
                              className='custom-dropdown btn btn-sm container-fluid dropdown-toggle text-right'
                              href='#'
                              role='button'
                              data-toggle='dropdown'
                              aria-haspopup='true'
                              aria-expanded='false'
                            >
                              <span className='filter-text'>
                                {this.state.activeEntity === '' ? 'يرجى تحديد الكيان' : this.state.activeEntity}
                              </span>
                              <ChevronDown size={16} color="#404040" />
                              {/* <p className='m-0 filter pr-3'>{this.state.activePriority === '' ? 'يرجى تحديد الأولوية' : this.state.activePriority}</p> */}
                            </a>
                            <div className='dropdown-menu dropdown-menu-right overflow-auto text-right' 
                            dir="rtl">
                              {this.state.activeRecords.map((el, index) => {
                                if (!tempEntity.includes(el.EntityFullName)) {
                                  tempEntity.push(el.EntityFullName);
                                  return (
                                    <span className='dropdown-item pl-2 small' key={index} onClick={this.handleSelectEntity}>
                                      {el.EntityFullName}
                                    </span>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        </div>            
                      {/* Entity end */}      


                        {/* Priority start */}
                        {/* <div className='col-sm-12 col-md-12 col-lg-3 text-secondary px-2 mb-4'> */}
                        <div className='col-sm-6 col-md-6 col-lg-2 text-secondary px-2 pb-3 margin-10'>
                        
                          {/*<div className='col-sm-6 col-md-6 col-lg-3 text-secondary px-2 padding-top-20'>*/}
                          <div className='filterLabel'>
                          <small>{PromptsARB.filterPriority}</small>
                          </div>
                          <div className='dropdown'>
                            <a
                              className='custom-dropdown btn btn-sm container-fluid dropdown-toggle text-right'
                              href='#'
                              role='button'
                              data-toggle='dropdown'
                              aria-haspopup='true'
                              aria-expanded='false'
                            >
                              <span className='filter-text'>
                                {this.state.activePriority === '' ? 'يرجى تحديد الأولوية' : this.state.activePriority}
                              </span>
                              <ChevronDown size={16} color="#404040" />
                              {/* <p className='m-0 filter pr-3'>{this.state.activePriority === '' ? 'يرجى تحديد الأولوية' : this.state.activePriority}</p> */}
                            </a>
                            <div className='dropdown-menu dropdown-menu-right overflow-auto text-right' 
                            dir="rtl">
                              {this.state.activeRecords.map((el, index) => {
                                if (!tempPriority.includes(el.Priority)) {
                                  tempPriority.push(el.Priority);
                                  return (
                                    <span className='dropdown-item pl-2 small' key={index} onClick={this.handleSelectPriority}>
                                      {el.Priority}
                                    </span>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        </div>   
                      
                        {/* Priority end */}

                        {/* Beneficiary start */}
                        <div className='col-sm-6 col-md-6 col-lg-2 text-secondary px-2 pb-3 margin-10'>
                        {/*<div className='col-sm-6 col-md-6 col-lg-3 text-secondary px-2 mb-4 padding-top-20'>*/}
                          <div className='filterLabel'>
                        <small>{PromptsARB.filterBeneficiary}</small>
                          </div>
                          <div className='dropdown'>
                            <a
                              className='custom-dropdown btn btn-sm container-fluid text-left dropdown-toggle text-right'
                              href='#'
                              role='button'
                              data-toggle='dropdown'
                              aria-haspopup='true'
                              aria-expanded='false'
                            >
                              <span className='filter-text'>
                                {this.state.activeBeneficiary === '' ? 'يرجى اختيار الجهة المستفيدة' : this.state.activeBeneficiary}
                              </span>

                              <ChevronDown size={16} color="#404040" />
                            </a>
                            <div className='dropdown-menu dropdown-menu-right overflow-auto text-right' 
                            dir="rtl"
                            >
                            {this.state.activeRecords.map((el, index) => {
                              // this gets rid of the blank Beneficiary label, was 'enabling', 'other'
                              if (!tempBeneficiary.includes(el.Beneficiary) && el.Beneficiary !== ""  && el.Beneficiary !== " "  && el.Beneficiary !== "أخرى"  && el.Beneficiary !== "التمكين") {
                                tempBeneficiary.push(el.Beneficiary);
                                return (
                                  <span className='dropdown-item pl-2 small' key={index} onClick={this.handleSelectBeneficiary}>
                                    {el.Beneficiary}
                                  </span>
                                );
                              }
                              // this gets rid of the blank BeneficiaryTwo label, was 'enabling', 'other'
                              if (!tempBeneficiary.includes(el.BeneficiaryTwo) && el.BeneficiaryTwo !== "" && el.BeneficiaryTwo !== " " && el.BeneficiaryTwo !== "أخرى" && el.BeneficiaryTwo !== "التمكين") {
                                tempBeneficiary.push(el.BeneficiaryTwo);
                                return (
                                  <span className='dropdown-item pl-2 small' key={index} onClick={this.handleSelectBeneficiary}>
                                    {el.BeneficiaryTwo}
                                  </span>
                                );
                              }
                              return null; // Return null if neither Beneficiary nor BeneficiaryTwo were added
                            })}
                            </div>
                          </div>
                        </div>
                        {/* Beneficiary end */}

                        {/* Results start */}
                        <div className='col-sm-6 col-md-6 col-lg-2 text-secondary px-2 pb-3 margin-10'>
                          {/*<div className='col-sm-12 col-md-12 col-lg-6 text-secondary px-2'>*/}
                          <div className='filterLabel'>
                            <small>{PromptsARB.filter4}</small>
                          </div>

                          <div className='dropdown'>
                            <div className='custom-dropdown btn btn-sm container-fluid text-left dropdown-toggle pt-half-sm text-right'>
                             
                              <Autosuggest
                                shouldRenderSuggestions={() => true}
                                inputProps={{
                                  placeholder: PromptsARB.resultsCategoryHint,
                                  name: 'resultsCategory',
                                  value: this.state.typedResultsCategory,
                                  onChange: (event, { newValue }) => {
                                    tempBudgetSection = [];
                                    tempSubprogramme = [];
                                    tempBeneficiary = [];
                                    tempPriority = [];
                                    tempEntity = [];
                                    this.setState({ typedResultsCategory: newValue });
                                  },
                                }}
                                suggestions={this.state.resultsCategorySuggestions}
                                onSuggestionsFetchRequested={({ value }) => {
                                  if (!value) {
                                    tempBudgetSection = [];
                                    tempSubprogramme = [];
                                    tempBeneficiary = [];
                                    tempPriority = [];
                                    tempEntity = [];
                                    this.setState({ resultsCategorySuggestions: this.state.activeSpecificResults });
                                    return;
                                  } else {
                                    tempBudgetSection = [];
                                    tempSubprogramme = [];
                                    tempBeneficiary = [];
                                    tempPriority = [];
                                    tempEntity = [];
                                    let tempArray = [];
                                    this.state.activeSpecificResults.map((item) => {
                                      if (item.toLowerCase().includes(value.toLowerCase())) {
                                        tempArray.push(item);
                                      }
                                    });
                                    this.setState({ resultsCategorySuggestions: tempArray });
                                    return;
                                  }
                                }}
                                onSuggestionsClearRequested={() => {
                                  tempBudgetSection = [];
                                  tempSubprogramme = [];
                                  tempBeneficiary = [];
                                  tempPriority = [];
                                  tempEntity = [];
                                  this.setState({ resultsCategorySuggestions: [] });
                                }}
                                onSuggestionSelected={(event, { suggestion }) => {
                                  selectedSpecifResult = suggestion;
                                  let tempSelectedRecords = this.state.activeRecords.filter((el) => el.SpecificResult === selectedSpecifResult);
                                  let tempISOs = [];
                                  tempBudgetSection = [];
                                  tempSubprogramme = [];
                                  tempBeneficiary = [];
                                  tempPriority = [];
                                  tempEntity = [];
                                  if (this.state.activeISOs.length === 1) {
                                    tempISOs.push(this.state.activeISOs[0]);
                                    this.setState(
                                      {
                                        activeRecords: tempSelectedRecords,
                                        buffingRecords: tempSelectedRecords,
                                        specificResultSelected: selectedSpecifResult,
                                        // activeSpecificResults:[selectedSpecifResult],
                                        activeISOs: tempISOs,
                                      },
                                      () => {
                                        this.setState({
                                          activeISOs: tempISOs,
                                        });
                                        this.state.backupISOs.map((el) => {
                                          polygonSeries.getPolygonById(el).isActive = false;
                                        });
                                        tempISOs.map((el) => {
                                          polygonSeries.getPolygonById(el).isActive = true;
                                        });
                                        tempBudgetSection = [];
                                        tempSubprogramme = [];
                                        tempBeneficiary = [];
                                        tempPriority = [];
                                        tempEntity = [];
                                      }
                                    );
                                  } else {
                                    tempSelectedRecords.map((el) => {
                                      el.ISO2.split(',').map((item) => {
                                        if (!tempISOs.includes(item) && item.length === 2) {
                                          tempISOs.push(item);
                                        }
                                      });
                                    });
                                    this.setState(
                                      {
                                        // activeSpecificResults:[selectedSpecifResult],
                                        activeRecords: tempSelectedRecords,
                                        buffingRecords: tempSelectedRecords,
                                        specificResultSelected: selectedSpecifResult,
                                        memberStateSelected: '',
                                      },
                                      () => {
                                        this.setState({
                                          activeISOs: tempISOs,
                                        });
                                        this.state.backupISOs.map((el) => {
                                          polygonSeries.getPolygonById(el).isActive = false;
                                        });
                                        tempISOs.map((el) => {
                                          polygonSeries.getPolygonById(el).isActive = true;
                                        });
                                        tempBudgetSection = [];
                                        tempSubprogramme = [];
                                        tempBeneficiary = [];
                                        tempPriority = [];
                                        tempEntity = [];
                                      }
                                    );
                                  }
                                }}
                                getSuggestionValue={(suggestion) => suggestion}
                                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                              />
                              {/* </div> */}
                              <div className='clearTyped'>
                                <button
                                  disabled={this.state.typedResultsCategory === '' ? true : false}
                                  type='button'
                                  className='close'
                                  aria-label='Close'
                                  onClick={this.handleClickRefresh}
                                >
                                  {/* <span aria-hidden="true">&times;</span> */}
                                  {/* <Delete width='15px' height='15px' strokeWidth='2' enableBackground='true' /> */}
                                  {this.state.typedResultsCategory !== '' && <X size={15} />}
                                </button>
                              </div>
                            </div> {/* custom end */}
                          </div> {/* dropdown end */}
                        </div> {/* col end */}
                        {/* Results end */}

                        {/* Progbudget sect start */}
                        <div className='col-sm-6 col-md-6 col-lg-2 text-secondary px-2 pb-3 margin-10'>
                          <div className='filterLabel'>
                            <small>{PromptsARB.filter2}</small>
                          </div>

                          <div className='dropdown filterContainer'>
                            <a
                              className='custom-dropdown btn btn-sm container-fluid text-left dropdown-toggle text-right'
                              href='#'
                              role='button'
                              // id='dropdownMenuLink1'
                              data-toggle='dropdown'
                              aria-haspopup='true'
                              aria-expanded='false'
                            >
                              <span className='filter-text'>
                                {this.state.activeBudgetSection === '' ? PromptsARB.placeholder2 : this.state.activeBudgetSection}
                              </span>

                               <ChevronDown size={16} color="#404040" />
                            </a>
                            <div className='dropdown-menu overflow-auto dropdown-menu-right text-right'>
                              {this.state.activeRecords.map((el, index) => {
                                if (!tempBudgetSection.includes(el.BudgetSection + ': ' + el.Programme)) {
                                  tempBudgetSection.push(el.BudgetSection + ': ' + el.Programme);
                                  return (
                                    <span className='dropdown-item pl-2 small' key={index} onClick={this.handleSelectBudgetSection}>
                                      {el.BudgetSection + ': ' + el.Programme.trim()}
                                    </span>
                                  );
                                }
                              })}
                            </div> {/* dropdown-menu end */}
                          </div> {/* dropdown end */}
                        </div> {/* col end */}
                      
                        {/* Progbudget sect end */}

                        {/* Subprogramme start */}
                        <div className='col-sm-6 col-md-6 col-lg-2 text-secondary px-2 pb-3 margin-10'>
                          <div className='filterLabel'>
                            <small>{PromptsARB.filter3}</small>
                          </div>
                          
                          {/* <div className='row form-inline filterContainer'> */}
                            <div className='dropdown filterContainer' title={PromptsARB.budgetSectionFirst}>
                              <a
                                className={
                                  this.state.activeBudgetSection !== ''
                                    ? 'custom-dropdown btn btn-secondary btn-sm dropdown-toggle container-fluid text-right'
                                    : 'custom-dropdown btn btn-secondary btn-sm dropdown-toggle container-fluid text-right disabled'
                                }
                                href='#'
                                role='button'
                                // id='dropdownMenuLink2'
                                data-toggle='dropdown'
                                aria-haspopup='true'
                                aria-expanded='false'
                              >
                                <span className='filter-text'>
                                  {this.state.activeSubprogramme === '' ? PromptsARB.placeholder3 : this.state.activeSubprogramme}
                                </span>
                                    <ChevronDown size={16} color="#404040" />


                              </a>
                              <div className='dropdown-menu overflow-auto dropdown-menu-right text-right'>
                                {this.state.activeRecords.map((el, index) => {
                                  if (!tempSubprogramme.includes(el.Subprogramme)) {
                                    tempSubprogramme.push(el.Subprogramme);
                                    return (
                                      <span className='dropdown-item pl-2 small' key={index} onClick={this.handleSelectSubprogramme}>
                                        {el.Subprogramme.trim()}
                                      </span>
                                    );
                                  }
                                })}
                              </div>
                            </div>


                            {/* <div className='row form-inline filterContainer'>
                              <button
                                className='btn btn-sm btn-outline-secondary border-0'
                                type='button'
                                title='refresh'
                                onClick={this.handleClickRefresh}
                                id='button-addon2'
                              >
                                <RefreshCcw width='25px' height='25px' color='#00b0f1' strokeWidth='3.5' enableBackground='true' />
                              </button>
                            </div> */}

                          {/* </div> */}
                        </div>
                        {/* Subprogramme end */}

                      </div> {/* row filter-bars end */} 
                    </div> {/* filtersCollapse end */} 
                  </div> {/* accordion-item end */}

                </div>
                {/* Accordion test: end */} 



                <div className='col-3 px-2 pt-4 pb-3 margin-10'>
                <button
                  type='button'
                  id='btnClear'
                  className='new_btn'
                  title='refresh'
                  onClick={this.handleClickRefresh}
                >
                  <i className="bx bx-reset" aria-hidden="true"></i> امسح
                </button>
              </div>


              

            </div> {/* row end */} 
          </div> {/* CONTAINER FLUID *** */}

          {/* CONTAINER FOR CONTAINERS: CaptionARB/mandate, container */}
          {/* <div className='row main-content text-right' style={{ marginBottom: '3.2rem' }}> */}
          <div className='row main-content text-right'>
                    {/* <div className='col-sm-12 col-md-12 col-lg-6 px-3 pb-5'> */}
                    <div className='col-sm-12 col-md-12 col-lg-6 px-3 lg-pt-30'>
                      <div id='chartdiv'>
                      </div>
                       <div
                                    style={{
                                      // width: '700px',
                                      // height: 'px', 
                                      background: '#F5f5f5',
                                      // background: '#Fcfcfc',
                                      display: 'flex',
                                      alignItems: 'stretch',
                                      //padding: '0 0 0 12px',  // space for vertical line
                                      boxSizing: 'border-box',
                                      overflowY: 'auto',        // vertical scroll if content exceeds height
                                      marginRight: '5px',
                                      marginTop: '5px',
                                      marginLeft: '5px',
                                      marginBottom: '10px',
                                    }}
                                    >
                                    {/* Vertical line */}
                                    <div
                                      style={{
                                        width: '4px',
                                        backgroundColor: '#009EDB',
                                        // marginRight: '12px',
                                        flexShrink: 0,
                                      }}
                                    ></div>
                      
                                    {/* Text content */}
                                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1  }}>
                                      {/* Caption text */}
                                      <p
                                        className='small my-0 map-caption'
                                        style={{
                                          marginRight: '10px',
                                          paddingTop: '10px',
                                          paddingBottom: '8px',
                                          // paddingRight: '20px',
                                          paddingLeft: '20px',
                                          //font: 'normal normal normal 8px/12px Roboto',
                                          color: '#8c8c8c',
                                          // color: '#cdcdcd',
                                          // letterSpacing: '0.5px',
                                          // lineHeight: '1.2',
                                        }}
                                      >
                                        {CaptionARB}
                                      </p>
                      
                                      {/* Link under caption */}
                                      {/* <li
  className="leaf list-unstyled d-inline-block"
  style={{ marginTop: '0px', direction: 'ltr' }}
>
  <a
    href="https://mandates.un.org"
    target="_blank"
    rel="noopener noreferrer"
    className="small map-caption text-decoration-none d-inline-flex align-items-center"
    style={{
      color: '#cdcdcd',
      textAlign: 'left'
    }}
  >
    mandates.un.org
  </a>
</li> */}

                                  {/* <li
                                    className="leaf list-unstyled d-inline-flex"
                                    style={{
                                      marginTop: '0px',
                                      direction: 'ltr',
                                      justifyContent: 'flex-start'
                                    }}
                                  >
                                    <a
                                      href="https://mandates.un.org"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="small map-caption text-decoration-none d-inline-flex align-items-center"
                                      style={{ color: '#7F7F7F' }}
                                    >
                                      mandates.un.org
                                    </a>
                                  </li> */}
                                      {/* <li className="leaf list-unstyled d-inline-block" style={{ marginTop: '0px' }}>
                                        <a
                                          href="https://mandates.un.org"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="small map-caption text-decoration-none d-inline-flex align-items-center text-right"
                                          style={{ color: '#cdcdcd'}}
                                        >
                                          mandates.un.org
                                        </a>
                                      </li> */}
                                    </div>
                                  </div>

                      {/* IMAGE BOX START */}
                <div
                  style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '10px',
                    paddingTop: '5px',
                    paddingLeft: '2px',
                    paddingRight: '5px',
                    marginRight: '5px',
                    // padding: '12px',
                    display: 'inline-block',
                    textAlign: 'center',
                    backgroundColor: '#fff',
                    marginBottom: '10px',
                  }}
                >
                  <a
                    href="https://mandates.un.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    <img
                      src="/img/mandates.jpg"
                      alt="Mandates"
                      style={{
                        width: '100%',
                        maxWidth: '116px',
                        maxHeight: '25px',
                        borderRadius: '8px',
                        display: 'block',
                        // marginBottom: '8px',
                      }}
                    />
                  </a>

                  <li
                    className="leaf list-unstyled d-inline-block"
                    style={{ marginTop: '0px' }}
                  >
                    <a
                      href="https://mandates.un.org"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="small map-caption text-decoration-none ml-2 d-inline-flex align-items-center"
                      style={{ color: '#7F7F7F' }}
                    >
                      mandates.un.org
                    </a>
                  </li>
                </div>
                {/* IMAGE BOX END */}

                      {/* <p className='small my-0 map-caption'>{CaptionARB}</p>
                        <a
                      href='https://mandates.un.org'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='small map-caption text-decoration-none d-inline-flex align-items-center mt-2 mb-3'
                      style={{ color: '#00b0f1', fontSize: '0.85rem' }}
                    >
                      <i className='fa fa-link mr-2'></i>
                      mandates.un.org
                    </a> */}
          
          
                    </div>

            {/* <div id='subprogramme-stories' className='col-sm-12 col-md-12 col-lg-6 px-3 container-fluid arab-stories' dir='rtl'> */}
             <div id='subprogramme-stories' className='col-sm-12 col-md-12 col-lg-6 px-3' dir='rtl'>
              <div className='row results-count pt-0 pb-0'>
                
                {/* <div className='col-3 px-0 ml-0  w-100'> */}
                 <div className="col-6 px-0 ml-0 checkbox-inline">

                  {/* CHECKBOXES Solid: start */}
                  <div className='form-check form-check-inline text-secondary pb-0'>
                    <input 
                      type='checkbox' 
                      className="customCheckbox checkbox-inline"
                      checked={this.state.checked2025} 
                      onChange={this.handleClick2025} 
                      />
                    <span className='checkbox-align pr-1 small pt-1'> 2025</span>
                  </div>

                  <div className='form-check form-check-inline text-secondary pb-0'>
                    <input type='checkbox' 
                    className="customCheckbox checkbox-inline"
                    checked={this.state.checked2027} 
                    onChange={this.handleClick2027} />
                    <span className='checkbox-align pr-1 small pt-1'> 2027</span>
                  </div>
                   {/* CHECKBOXES solid: end */}  


                </div> {/* col6 end */}

                {/* RESULTS COUNT */}
                <div className='col-5 text-left text-secondary pt-2 px-0 mb-3 small pb-0 pt-1'>
                  {this.state.activeRecords.length + PromptsARB.resultsCount}
                </div>

                <div className='col-6 px-0 float-right' dir='rtl'>
                  {this.state.specificResultSelected === '' &&
                  this.state.budgetSectionSelected === '' &&
                  this.state.subprogrammeSelected === '' &&
                  this.state.memberStateSelected === '' &&
                  this.state.beneficiarySelected === '' &&
                  this.state.prioritySelected === '' &&
                  this.state.entitySelected === '' ? (
                    <div className='p-0 m-0'></div>
                  ) : (
                    <p className='text-secondary mt-1 ml-0 ml-1 mr-1 small float-right'>{PromptsARB.appliedFilters}</p>
                  )}
                  {this.state.specificResultSelected !== '' ? (
                    <div className='applied-filter float-right small text-secondary rounded'>{PromptsARB.filter4}</div>
                  ) : (
                    <div className='p-0 m-0'></div>
                  )}
                  {this.state.budgetSectionSelected !== '' ? (
                    <div className='applied-filter float-right small text-secondary rounded'>{PromptsARB.filter2}</div>
                  ) : (
                    <div className='p-0 m-0'></div>
                  )}
                  {this.state.subprogrammeSelected !== '' ? (
                    <div className='applied-filter float-right small text-secondary rounded'>{PromptsARB.filter3}</div>
                  ) : (
                    <div className='p-0 m-0'></div>
                  )}
                  {/* {this.state.memberStateSelected !== '' ? (
                    <div className='applied-filter float-right small text-secondary rounded p-1'>{PromptsARB.memberState}</div>
                  ) : (
                    <div className='p-0 m-0'></div>
                  )} */}
                  {this.state.beneficiarySelected !== '' ? (
                    <div className='applied-filter float-right small text-secondary rounded'>{PromptsARB.filterBeneficiary}</div>
                  ) : (
                    <div className='p-0 m-0'></div>
                  )}
                  {this.state.prioritySelected !== '' ? (
                    <div className='applied-filter float-right small text-secondary rounded'>{PromptsARB.filterPriority}</div>
                  ) : (
                    <div className='p-0 m-0'></div>
                  )}
                  {this.state.entitySelected !== '' ? (
                    <div className='applied-filter float-right small text-secondary rounded'>{PromptsARB.entityTitle}</div>
                  ) : (
                    <div className='p-0 m-0'></div>
                  )}
                </div>
                {/* <div className='col-3 text-right text-secondary px-0 small pb-2'>{this.state.activeRecords.length + PromptsARB.resultsCount}</div> */}
              </div>

              <div className='stories'>
        {/* COVID key*/}
            <div className='card mb-3 rounded'>
              {/* <div className='col-12 text-right text-secondary px-0 small my-0 map-caption'><mark><font color="#c9ba89"><b>{PromptsARB.covidPrompt}</b></font></mark></div> */}
            </div>
        {/*Document list*/}
                {this.state.activeRecords.map((el, index) => {
                  return (
                    <div key={index} className='card shadow-sm mb-3 bg-light rounded'>
                      <div
                        className='card-body'
                        onMouseEnter={this.handleMouseEnter}
                        onMouseLeave={this.handleMouseLeave}
                        style={{ backgroundColor: el.COVID_Related === 'yes' ? '#FDEEC0' : '#f8f9fa' }}
                      >
              {/*
                        {el.Image !== '' ? (
                          <img
                            className='float-right story-image hover-image-arb'
                            id={'img' + el.ID}
                            src={require('./storyImages/ARB/' + el.Image)}
                            alt=''
                          />
                        ) : (
                          <div className='m-0 p-0'></div>
                        )}
            */}
              {/* ARB clickable image */}
                      <a data-toggle='modal' data-target={'#' + 'modal' + el.ID.toString()} className='image-wrapper float-left pt-2'>
                        {el.Image !== '' ? (
                          <img className='story-image' src={require('./storyImages/ARB/' + el.Image)} alt='' />
                        ) : (
                          <div className='m-0 p-0'></div>
                        )}
                        <p className='card-subtitle pt-2 small'></p>
                        <p className='card-subtitle pt-1 small subprogramme'> 
                          <strong><font color="#46a628">{el.Target === 'Target met' ? PromptsARB.targetMet : ''}</font></strong>
                        </p>
                        <p className='card-subtitle pt-2 small'></p> 
                        <p className='card-subtitle pt-1 small subprogramme'> 
                          <strong><font color="#2a7014">{el.Target === 'Target exceeded' ? PromptsARB.targetExceeded : ''}</font></strong>
                        </p>
                        <p className='card-subtitle pt-2 small'></p> 
                        <p className='card-subtitle pt-1 small subprogramme'> 
                          <strong><font color="#eb8509">{el.Target === 'Target not met' ? PromptsARB.targetNotMet : ''}</font></strong>
                        </p>
            </a>
                      <div
                        className='modal fade text-center'
                        id={'modal' + el.ID.toString()}
                        tabIndex='-1'
                        role='dialog'
                        aria-labelledby={el.ID.toString() + 'modalLabel'}
                        aria-hidden='true'
                      >
                        {/* {el.Image !== '' ? (
                          <img className='modal-dialog story-image-lg' src={require('./storyImages/ARB_big/' + el.image_big)} alt={el.image_big} />
                        ) : (
                          <div className='m-0 p-0'></div>
                        )} */}
                        {el.Image !== '' ? (
                          <img className='modal-dialog story-image-lg' src={require('./storyImages/ARB/' + el.Image)} alt={el.Image} />
                        ) : (
                          <div className='m-0 p-0'></div>
                        )}
            </div>  
                
                        <a href={el.URL} target='_blank' >
                        <h6 className='card-title mb-1'><font color="black">{el.Title}</font></h6>
                        </a>{' '}

                        {/* ---------------- LINK TO DOCUMENT ---------------- */}
                        {/*<span className='card-subtitle text-muted small'>
                          {PromptsARB.source}
                          <a href={el.URL} target='_blank'>
                            {el.URL === '' ? 'N/A' : el.URL}
                          </a>{' '}
                        </span>}*/}
                        {/* ------------------------------------------------- */}

                        <p className='card-subtitle pt-2 small'></p> {/* SPACE */}
                        <p className='card-subtitle pt-1 small'>
                          <strong>{PromptsARB.budgetSection + el.BudgetSection}</strong>: {el.Programme}
                        </p>
                        <p className='card-subtitle pt-1 small'>
                          <strong>{PromptsARB.subprogramme}</strong>: {el.Subprogramme}
                        </p>
                        <p className='card-subtitle pt-1 small subprogramme'>
                          <strong><font color="#c9ba89">{el.COVID_Related === 'yes' ? PromptsARB.covidPrompt2 : ''}</font></strong>
                        </p>

                          {/* OLD STORIES WITH DROPDOWN CHEVRON */}
                        {/*<div
                          className='bg-transparent border-0 collapse-button read-more'
                          type='button'
                          data-toggle='collapse'
                          data-target={'#' + 'record' + el.ID.toString()}
                          aria-expanded='false'
                          aria-controls='collapseExample'
                        >
                          <ChevronDown width='20px' strokeWidth='5' stroke='#6D6E71' />
                        </div>

                        <div className='collapse' id={'record' + el.ID.toString()}>

                          <div
                            className='modal fade text-center'
                            id={'modal' + el.ID.toString()}
                            tabIndex='-1'
                            role='dialog'
                            aria-labelledby={el.ID.toString() + 'modalLabel'}
                            aria-hidden='true'
                          >
                          </div>
                          <p className='card-text pt-1 single-post-content-wrapper small'>{el.Story}</p>
                        </div>*/}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>


          
            <footer className="footer-un2 footer-container dark">
              <div className="section-fluid footer-fluid">


                  {/* CONTACT LINKS */}

                  <div className="row footer-links">
                    <div className="col-md-12">
                      {/* <div className="divider"></div> */}
                      <div className="text-right"> 
                        <div id="block-menu-menu-footer-links" class="block block-menu" role="navigation">
                          <ul className="nav list-inline">
                            <li class="list-inline-item"><a href="https://www.un.org/ar/site-index">&nbsp;&nbsp;&nbsp;دليل الموقع</a></li>
                            <li class="list-inline-item "><a href="https://www.un.org/ar/contact-us-0">&nbsp;&nbsp;&nbsp;اتصل بنا</a></li>
                            <li class="list-inline-item "><a href="https://www.un.org/ar/about-us/copyright">&nbsp;&nbsp;&nbsp;حقوق النشر والطبع</a></li>
                            <li class="list-inline-item "><a href="https://www.un.org/ar/about-us/frequently-asked-questions">&nbsp;&nbsp;&nbsp;أسئلة شائعة</a></li>
                            <li class="list-inline-item "><a href="https://www.un.org/ar/about-us/fraud-alert">&nbsp;&nbsp;&nbsp;تحذير من عمليات إحتيال</a></li>
                            <li class="list-inline-item "><a href="https://www.un.org/ar/about-us/privacy-notice">&nbsp;&nbsp;&nbsp;بيان الخصوصيات</a></li>
                            <li class="list-inline-item last"><a href="https://www.un.org/ar/about-us/terms-of-use">شروط الإستخدام</a></li>
                          </ul> 
                        </div> 
                      </div>
                    </div>                 
                </div>


          {/* SOCIAL MEDIA */}

            <div className="footer-box">
            
              <div className="row">
                  <div className="col-md-12">


                    {/* DIVIDER */}

                      <div className="divider"></div>


                      {/* CONTAINER FOR SOCIAL AND DONATION */}

                        <div className="footer-row mb-2 pt-1 pb-1">

                    {/* <div className="pull-right flip footer-brand ar-footer float-right">  
                      <a href="https://www.un.org/ar/" title="Home">
                      <span className="site-name">United Nations</span></a>
                    </div> */}


                    {/* <div className="pull-left flip donate-ar">
                      <a href="https://www.un.org/ar/about-us/how-to-donate-to-the-un-system/" className="btn btn-footer btn-default btn-reverse dark" role="button" id="donate_button">تبرعوا</a>
                    </div> */}
                    <div className="pull-left flip social-media" role="navigation">
                      <ul className="nav list-inline">
                        <li className="list-inline-item facebook pl-1"><a href="https://www.facebook.com/UnitedNationsArabic"><span class="icon-text">facebook</span></a></li>
                        <li className="list-inline-item twitter pl-2"><a href="https://twitter.com/UNarabic"><span class="icon-text">twitter</span></a></li>
                        <li className="list-inline-item youtube pl-2"><a href="https://www.youtube.com/user/UNarabic"><span class="icon-text">youtube</span></a></li>
                        <li className="list-inline-item flickr pl-3"><a href="https://www.flickr.com/photos/un_photo/"><span class="icon-text">flickr</span></a></li>
                        <li className="list-inline-item instagram pl-2"><a href="http://instagram.com/unitednations"><span class="icon-text">instagram</span></a></li>					
                      </ul> 
                    </div>

                    <div className="pull-left flip donate-ar">
                      <a href="https://www.un.org/ar/about-us/how-to-donate-to-the-un-system/" className="btn btn-footer btn-default btn-reverse dark pl-4 pr-3" role="button" id="donate_button"style={{
                                border: "2px solid #1C4969",
                                borderRadius: "5px",
                                backgroundColor: "#ffffff",
                                padding: "5px 10px",
                                color: "#1C4969",
                                opacity: '100%',
                                textAlign: "center",
                              }}><i className="fas fa-hand-holding-heart pr-2 pl-2 pt-1 pb-1" style={{ color: "#009edb", fontSize: "13px"  }}></i>تبرعوا</a>
                    </div>

                    </div>  {/* end: CONTAINER FOR SOCIAL AND DONATION */}
                    
                  </div>
                </div>
              </div>

                {/* <div className="row footer-links">
                    <div className="col-md-12">
                      <div className="divider"></div>
                      <div className="text-right"> 
                        <div id="block-menu-menu-footer-links" class="block block-menu" role="navigation">
                          <ul className="nav list-inline">
                            <li className="list-inline-item"><a href="https://www.un.org/ar/site-index">&nbsp;&nbsp;&nbsp;دليل الموقع</a></li>
                            <li class="list-inline-item "><a href="https://www.un.org/ar/contact-us-0">&nbsp;&nbsp;&nbsp;اتصل بنا</a></li>
                            <li class="list-inline-item "><a href="https://www.un.org/ar/about-us/copyright">&nbsp;&nbsp;&nbsp;حقوق النشر والطبع</a></li>
                            <li class="list-inline-item "><a href="https://www.un.org/ar/about-us/frequently-asked-questions">&nbsp;&nbsp;&nbsp;أسئلة شائعة</a></li>
                            <li class="list-inline-item "><a href="https://www.un.org/ar/about-us/fraud-alert">&nbsp;&nbsp;&nbsp;تحذير من عمليات إحتيال</a></li>
                            <li class="list-inline-item "><a href="https://www.un.org/ar/about-us/privacy-notice">&nbsp;&nbsp;&nbsp;بيان الخصوصيات</a></li>
                            <li class="list-inline-item last"><a href="https://www.un.org/ar/about-us/terms-of-use">شروط الإستخدام</a></li>
                          </ul> 
                        </div> 
                      </div>
                    </div>                 
                </div> */}
               </div> 
            </footer>
          
        </div>

      </React.Fragment>
    );
  }
}

export default ARB;
